import Vue from "vue";
import Viewer from "./src/index";
import mixins from "../mixins";
Vue.mixin(mixins);
// 全局定义echarts
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
//import 'echarts-liquidfill'
// import 'echarts-gl'
Vue.component("v-chart", ECharts);

Viewer.install = function (Vue) {
    Vue.component(Viewer.name, Viewer);
};

export default Viewer;
